export default __webpack_public_path__ + "static/lp-men-hero-mobile-d7f89c1ec885f93cb8ac45a905f49b26.webp";